/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddOrUpdateReceiveAddressVo,
  ResponsePageDataReceiveAddressVo,
  ResponseReceiveAddressVo,
  ResponseString,
} from '../models/index';
import {
    AddOrUpdateReceiveAddressVoFromJSON,
    AddOrUpdateReceiveAddressVoToJSON,
    ResponsePageDataReceiveAddressVoFromJSON,
    ResponsePageDataReceiveAddressVoToJSON,
    ResponseReceiveAddressVoFromJSON,
    ResponseReceiveAddressVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface ReceiveAddressCreatePostRequest {
    addOrUpdateReceiveAddressVo?: AddOrUpdateReceiveAddressVo;
}

export interface ReceiveAddressIdDeleteRequest {
    id: number;
}

export interface ReceiveAddressIdGetRequest {
    id: number;
}

export interface ReceiveAddressIdPutRequest {
    id: number;
    addOrUpdateReceiveAddressVo?: AddOrUpdateReceiveAddressVo;
}

export interface ReceiveAddressPageGetRequest {
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    ctmsType?: number;
    nameKr?: string;
    zip?: string;
    mobileNo?: string;
}

export interface ReceiveAddressSetDefaultIdPutRequest {
    id: number;
    userId: number;
    defaultChoice?: number;
}

/**
 * 
 */
export class ReceiveAddressControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 创建收货地址
     */
    async receiveAddressCreatePostRaw(requestParameters: ReceiveAddressCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateReceiveAddressVoToJSON(requestParameters['addOrUpdateReceiveAddressVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 创建收货地址
     */
    async receiveAddressCreatePost(requestParameters: ReceiveAddressCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.receiveAddressCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除收货地址
     */
    async receiveAddressIdDeleteRaw(requestParameters: ReceiveAddressIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiveAddressIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除收货地址
     */
    async receiveAddressIdDelete(requestParameters: ReceiveAddressIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.receiveAddressIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取收货地址
     */
    async receiveAddressIdGetRaw(requestParameters: ReceiveAddressIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseReceiveAddressVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiveAddressIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseReceiveAddressVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取收货地址
     */
    async receiveAddressIdGet(requestParameters: ReceiveAddressIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseReceiveAddressVo> {
        const response = await this.receiveAddressIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新收货地址
     */
    async receiveAddressIdPutRaw(requestParameters: ReceiveAddressIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiveAddressIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateReceiveAddressVoToJSON(requestParameters['addOrUpdateReceiveAddressVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新收货地址
     */
    async receiveAddressIdPut(requestParameters: ReceiveAddressIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.receiveAddressIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分页查询收货地址
     */
    async receiveAddressPageGetRaw(requestParameters: ReceiveAddressPageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataReceiveAddressVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['ctmsType'] != null) {
            queryParameters['ctmsType'] = requestParameters['ctmsType'];
        }

        if (requestParameters['nameKr'] != null) {
            queryParameters['nameKr'] = requestParameters['nameKr'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        if (requestParameters['mobileNo'] != null) {
            queryParameters['mobileNo'] = requestParameters['mobileNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataReceiveAddressVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分页查询收货地址
     */
    async receiveAddressPageGet(requestParameters: ReceiveAddressPageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataReceiveAddressVo> {
        const response = await this.receiveAddressPageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 设置默认收货地址 0 非默认 1 默认，每种清关方式（个人/企业）各自保留一个默认
     */
    async receiveAddressSetDefaultIdPutRaw(requestParameters: ReceiveAddressSetDefaultIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling receiveAddressSetDefaultIdPut().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling receiveAddressSetDefaultIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['defaultChoice'] != null) {
            queryParameters['defaultChoice'] = requestParameters['defaultChoice'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/receiveAddress/setDefault/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 设置默认收货地址 0 非默认 1 默认，每种清关方式（个人/企业）各自保留一个默认
     */
    async receiveAddressSetDefaultIdPut(requestParameters: ReceiveAddressSetDefaultIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.receiveAddressSetDefaultIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
